import { useEffect } from "react";
import { connect } from "react-redux";
import { setLayout } from "../../redux/shellActions";
import ExternalLinkView from "../../../common/externalLink/ExternalLinkView";
import EmailLinkView from "../../../common/externalLink/EmailLinkView";

function Accessibility(props: any) {
    const { setLayout } = props;
    // initial load
    useEffect(() => {
        setLayout("Accessibility");
    }, [setLayout]);

    return (
        <>
            <p>
                We are committed to providing websites that are accessible to everyone. This is a requirement under the{" "}
                <ExternalLinkView href="https://www.legislation.gov.au/Series/C2004A04426">Disability Discrimination Act 1992</ExternalLinkView>.
            </p>
            <p>We aim to meet Web Content Accessibility Guidelines (WCAG) which is the web standard recommended by the Australian Government.</p>
            <h2>Browser compatibility</h2>
            <p>NEATS works on most browsers. To ensure a safe and optimal experience, please use the latest versions of Chrome, Edge and Safari.</p>
            <h2>Contact us</h2>
            <p>We want our website to meet the highest accessibility level possible.</p>
            <p>
                If you’re having difficulty accessing our documents or experience any accessibility or usability issues with our website please contact us at{" "}
                <EmailLinkView emailAddress="neats.admin@nopta.gov.au" />.
            </p>
        </>
    );
}

// connect redux
export default connect((state: any) => ({}), { setLayout })(Accessibility);
